module.exports = __webpack_public_path__ + "277225946fea1f1ad4c59cf41e15e5d2.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-ok/sp-ok.html
// module id = 1134
// module chunks = 0